import React from 'react';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { RepairOrReplace } from './components/RepairOrReplace';
import { ADAS } from './components/ADAS';
import { Insurance } from './components/Insurance';
import { Process } from './components/Process';
import { Locations } from './components/Locations';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <main className="w-full min-h-screen bg-white font-sans text-navy-900 pb-20 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBar data-id="element-2" />
      <Services data-id="element-3" />
      <RepairOrReplace data-id="element-4" />
      <ADAS data-id="element-5" />
      <Insurance data-id="element-6" />
      <Process data-id="element-7" />
      <Locations data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <StickyMobileCTA data-id="element-11" />
    </main>;
}